export default __webpack_public_path__ + "static/media/friend-forever.19b953fe.webp";